import BeneficiaryDataFormPresenter from './BeneficiaryDataFormPresenter';

export default class BeneficiaryDataFormPresenterFactory {
    static make = (onDataChange, updateState) => {
        let presenter = new BeneficiaryDataFormPresenter(onDataChange, updateState);
        return presenter;
    }
}